import type { EfaxProviderFacility } from '../../types/efax-provider-facility';
import { hasExtractedValue } from './efax-cell-utils';
import { MissingValue } from './MissingValue';

interface FacilityCellProps {
  facility: EfaxProviderFacility;
}

export const FacilityCell = ({ facility }: FacilityCellProps) => {
  if (!hasExtractedValue(facility.name)) {
    return <MissingValue />;
  }

  return (
    <div className="min-w-0 break-words whitespace-normal">
      <div className="font-medium break-words whitespace-normal">
        {facility.name}
      </div>
      <div className="text-muted-foreground text-xs break-words whitespace-normal">
        {hasExtractedValue(facility.type) ? facility.type : '—'}
      </div>
    </div>
  );
};
